import React from 'react';
import { useLang } from '@/contexts/LanguageContext';
import { PRODUCTS } from '@/data/products';
import ProductCard from '@/components/ProductCard';
import { PRODUCTS as TIDS } from '@/constants/testIds';

export default function ProductsPage() {
  const { t } = useLang();
  return (
    <div className="bg-[#FFFBFB]">
      <section className="px-6 md:px-12 lg:px-24 pt-16 md:pt-24 pb-12 md:pb-16">
        <div className="max-w-7xl mx-auto">
          <p className="text-[10px] md:text-xs font-bold tracking-[0.3em] uppercase text-[#FF7597]">
            {t('home.featuredEyebrow')}
          </p>
          <h1 className="font-display mt-3 text-5xl sm:text-6xl lg:text-7xl font-black tracking-tighter text-[#1F1A24] max-w-3xl">
            {t('products.title')}
          </h1>
          <p className="mt-4 text-base md:text-lg text-[#574A66] max-w-xl">
            {t('products.subtitle')}
          </p>
        </div>
      </section>

      <section className="px-6 md:px-12 lg:px-24 pb-24 md:pb-32" data-testid={TIDS.list}>
        <div className="max-w-7xl mx-auto grid grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8">
          {PRODUCTS.map((p, i) => (
            <ProductCard key={p.slug} product={p} index={i} />
          ))}
        </div>
      </section>
    </div>
  );
}
